// The service worker stores each successful content response under this cache;
// the page reads it back at boot. Both sides key by the request URL.
const CONTENT_CACHE_NAME = "content-cache";

const CONTENT_PATH = /\/screens\/[^/]+\/content\/v3$/;

function contentApiUrl(displayId: string, preview = false): string {
  const previewParam = preview ? "?preview=true" : "";
  return `${import.meta.env.VITE_ELEV8_API_BASE_URL}/screens/${displayId}/content/v3${previewParam}`;
}

function isContentRequest(url: URL): boolean {
  return CONTENT_PATH.test(url.pathname) && !url.searchParams.has("preview");
}

export { CONTENT_CACHE_NAME, contentApiUrl, isContentRequest };
